import React from 'react'
import without from 'lodash/without'
import FormCheckBox from 'components/forms/bases/FormCheckbox'
import FormLabel from 'components/labels/FormLabel'
import { addDelimeterBetweenItems } from 'helpers/stringHelpers'

const wrapperStyle = {
  padding: 15,
  marginBottom: 10,
}

const parseToForm = (value) => {
  // output as an array
  return value.split(' ')
}

const isValidValue = (value, list) => {
  return list.indexOf(value) !== -1
}


const returnValue = (val, key, list) => {
  const newList = without(
    val ?
      // val === true
      list.concat(key)
      :
      without(list, key),
    ''
  )
  return addDelimeterBetweenItems(newList, ' ')
}

const devices = [
  { label: 'Computer', key: 'computer' },
  { label: 'Tablet', key: 'tablet' },
  { label: 'Mobile', key: 'mobile' },
]

const AppearanceCheckbox = ({
  value,
  onChange,
}) => {
  const appears = parseToForm(value)
  return (
    <div>
      <FormLabel>Appearance</FormLabel>
      <div style={wrapperStyle}>
        <FormCheckBox
          label="All Devices"
          value={value === ''}
          onChange={(val) => onChange('')}
        />
        {devices.map(({ label, key }) => (
          <FormCheckBox
            key={key}
            label={label}
            value={isValidValue(key, appears)}
            onChange={(val) => onChange(returnValue(val, key, appears))}
          />
        ))}
      </div>
    </div>
  )
}

AppearanceCheckbox.propTypes = {}
AppearanceCheckbox.defaultProps = {}

export default AppearanceCheckbox



// WEBPACK FOOTER //
// ./src/components/forms/AppearanceCheckbox.js